import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { NotificationService } from '../../shared/notification/notification.service';
import { SpinnerService } from '../../spinner/spinner.service';
import { StaticInfoService } from '../../services/static-info.service';

@Component({
    selector: 'backend-download',
    templateUrl: './download.component.html',
    styleUrls: ['./download.component.css'],
    standalone: false
})
export class DownloadComponent {
  public staticInfo = null;
  public latestBuildText: string = 'Loading...';
  public latestIosBuildText: string = 'Loading...';

  public constructor(
    private readonly spinnerService: SpinnerService,
    private readonly notificationService: NotificationService,
    private readonly httpClient: HttpClient,
    private readonly staticInfoService: StaticInfoService
  ) {}

    ngOnInit() {
      if (!this.staticInfoService.hasStaticInfo()) {
        this.httpClient
          .get<any>(
            'assets/json/static-build-info.json?version=' +
              (Date.now() + Math.floor(100000 + Math.random() * 900000))
          )
          .subscribe((data) => {
            this.staticInfoService.setStaticInfo(data);
    
            const builds = data?.sections?.[0]?.builds || [];
            const latestBuild = builds.find(
              (build) => build.buildFile && build.buildFile.trim() !== ''
            );
    
            if (latestBuild) {
              this.latestBuildText = `• App Version: ${latestBuild.version}<br> • Size: ${latestBuild.size} MB <br>• Requires: Windows 10 or newer`;
              this.latestIosBuildText = `• App Version: ${latestBuild.version}<br> • Requires: iOS 15 or newer`;
            }
          });
      } else {
        const data = this.staticInfoService.getStaticInfo();
        const builds = data?.sections?.[0]?.builds || [];
        const latestBuild = builds.find(
          (build) => build.buildFile && build.buildFile.trim() !== ''
        );
        if (latestBuild) {
          this.latestBuildText = `• App Version: ${latestBuild.version}<br> • Size: ${latestBuild.size} MB <br>• Requires: Windows 10 or newer`;
          this.latestIosBuildText = `• App Version: ${latestBuild.version}<br> • Requires: iOS 15 or newer`;
        }
      }
    }

  downloadLatestBuild() {
    this.spinnerService.showSpinner();
    try {
      const jsonData = this.staticInfoService.getStaticInfo();
      if (!jsonData) {
        this.notificationService.error('Error', 'No build data available.');
        return;
      }
      const builds = jsonData?.sections?.[0]?.builds || [];
      const latestBuild = builds.find(
        (build) => build.buildFile && build.buildFile.trim() !== ''
      );
      if (latestBuild) {
        const downloadUrl = '/' + latestBuild.buildFile;
        window.open(downloadUrl, '_blank');
      } else {
        this.notificationService.error(
          'Download Error',
          'No downloadable build file was found.',
          null,
          null
        );
      }
    } catch (error) {
      console.error('Download failed:', error);
      this.notificationService.error(
        'Unexpected Error',
        'Something went wrong while downloading.',
        null,
        null
      );
    } finally {
      this.spinnerService.hideSpinner();
    }
  }
}
